export const requests = {
  // dev
  // checkLogin: 'http://auth.main5.amocrm2.saas/check_login',

  // prod
  checkLogin: 'https://amochats.ru/check_login',
};
